import DEFAULT_LOCALE from 'client/constants/locale'
import { useCallback } from 'react'
import useConfig from './useConfig'

export const useCurrencyFormatters = () => {
  const config = useConfig()
  const locale = config?.entity?.locale ?? DEFAULT_LOCALE

  const formatCurrency = useCallback((amount = 0, currencyCode = config?.entity?.currency.currencyCode) => {
    if (!currencyCode) {
      return amount
    }
    return new Intl.NumberFormat(locale, { style: 'currency', currency: currencyCode }).format(amount)
  }, [config?.entity?.currency.currencyCode, locale])

  return {
    formatCurrency,
  }
}
